// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__35lPj","buttons":"RemoveExpirationActionButtons_buttons__2bv4Y"};